import PropTypes from "prop-types";
import componentOrElement from "prop-types-extra/lib/componentOrElement";
import React from "react";
import ReactDOM from "react-dom";

export const Portal = ({ children, container }) => container ? ReactDOM.createPortal(children, container) : <></>;

Portal.propTypes = {
  container: PropTypes.oneOfType([componentOrElement, PropTypes.func]),
  children: PropTypes.node,
  onRendered: PropTypes.func
};

export default Portal;
